import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitPlanModel } from '@apps-common/types/portal/unit'

const getUnitPlans = async (productId: string): Promise<IUnitPlanModel[]> =>
  axios.get(`/Unit/GetUnitPlanList?productId=${productId}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitPlans

type Props = {
  config?: QueryConfig<QueryFnType>
  productId?: string
}

export const useGetUnitPlans = ({ config, productId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: ['getUnitPlans', productId],
    queryFn: () => getUnitPlans(productId || '')
  })
